







import { Component, Vue } from 'vue-property-decorator';
import { Menu as InnerMenu } from '../../blocks';
import { childrenRoutes } from '@/pages/profile/router';
import { MenuData } from '@/pages/profile/blocks';

@Component({
  components: {
    InnerMenu,
  },
})
export default class Info extends Vue {
  readonly menu: MenuData = childrenRoutes();
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/info/Info.vue